module.exports = __webpack_public_path__ + "img/chevron-right-green.c18954ee.svg";